// Story 2.6 — strings canónicas do scaffold agnóstico de provider de analítica.
// Zero strings mágicas espalhadas pelo módulo (project-context: sem magic strings).

// Chaves de env PÚBLICAS (browser). Nomes canónicos das vars. NÃO são usadas para LER a
// env (ver GOTCHA em config.readEnvConfig): o Next só inlina no bundle do browser refs
// ESTÁTICAS literais `process.env.NEXT_PUBLIC_FOO`; um acesso por chave computada viria
// undefined no cliente. Ficam aqui como documentação do contrato (usadas no .env.template).
export const ENV_MEASUREMENT_ID = "NEXT_PUBLIC_ANALYTICS_MEASUREMENT_ID"
export const ENV_PIXEL_ID = "NEXT_PUBLIC_ANALYTICS_PIXEL_ID"

// Nomes de evento (convenção neutra, GA4-shaped) consumidos por qualquer tag de vendor
// no cutover — não é lock-in de vendor.
export const EVENT_PAGE_VIEW = "page_view"
export const EVENT_BEGIN_CHECKOUT = "begin_checkout"
export const EVENT_PURCHASE = "purchase"

// Cookie de consentimento LGPD. Opt-in afirmativo: ausência/valor inválido ⇒ "unknown".
export const CONSENT_COOKIE_NAME = "ve_analytics_consent"
// ~180 dias em segundos (janela de renovação do consentimento).
export const CONSENT_COOKIE_MAX_AGE_SECONDS = 180 * 24 * 60 * 60
// Max-Age do cookie de RETIRADA (Story 10.10): 0 expira-o imediatamente e devolve o estado
// a "unknown", fazendo o banner reaparecer.
export const CONSENT_COOKIE_CLEARED_MAX_AGE_SECONDS = 0

// Evento de janela emitido pelo banner ao gravar a decisão. O loader (irmão no layout, sem
// acesso ao estado do banner) subscreve-o para re-emitir o page_view da página ATUAL quando
// o consentimento muda sem navegação — senão a landing view de toda sessão que consente na
// 1ª página seria perdida.
export const CONSENT_CHANGED_EVENT = "ve:analytics-consent-changed"

// Sink array-convenção neutro no browser (window.dataLayer). Consumido por GA4/GTM/Meta
// via tag; não é um vendor.
export const DATA_LAYER_KEY = "dataLayer"

// Moeda única da loja (região BRL) — usada como currency dos eventos de conversão.
export const DEFAULT_CURRENCY = "BRL"

// Divisor centavos → unidade maior de moeda (value convencional de evento de conversão).
export const CENTS_PER_UNIT = 100
